import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <div className="container-fluid py-5">
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-6 text-center">
            <div className="error-content">
              <h1 className="display-1 text-primary">404</h1>
              <h2 className="mb-4">Page Not Found</h2>
              <p className="mb-4">The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
              <Link to="/" className="btn btn-primary rounded-pill">
                <i className="fa fa-home me-2"></i>Back to Home
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound; 